import { render, staticRenderFns } from "./neighborViewEdit.vue?vue&type=template&id=9a07a2ac&"
import script from "./neighborViewEdit.vue?vue&type=script&lang=js&"
export * from "./neighborViewEdit.vue?vue&type=script&lang=js&"
import style0 from "./neighborViewEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports